import { i18n, waitFor } from '@goodboydigital/astro';
import { Sprite } from '@pixi/sprite';
import { Text } from '@pixi/text';
import gsap from 'gsap';

import { Shared } from '../App';
import { Widget } from './Widget';

const trophies: Record<number, string> = {
    1: 'gold-trophy',
    2: 'silver-trophy',
    3: 'bronze-trophy',
};

export class FinishPosition extends Widget
{
    private trophy: Sprite;
    private label: Text;

    constructor()
    {
        super();

        this.trophy = new Sprite();
        this.trophy.anchor.set(0.5);
        this.view.addChild(this.trophy);

        this.label = new Text(`III`, {
            fontFamily: 'lubalin',
            fill: 0xFFFFFF,
            align: 'center',
            fontSize: 50,
            lineJoin: 'round',
            stroke: 'black',
            strokeThickness: 10,
        });
        this.label.anchor.set(0.5, 0.8);
        this.view.addChild(this.label);
    }

    public async present(position: number, players: number, delay = 0): Promise<void>
    {
        await waitFor(delay * 1000);
        this.label.text = players > 1 ? i18n.translate('position', { position, players }) : String(position);

        const trophy = trophies[position];

        if (trophy) this.trophy.texture = Shared.assets.getTexture(trophy);
        this.trophy.visible = !!trophy;

        await this.open();
        await waitFor(2500);
        await this.close();
    }

    protected async onOpen(): Promise<void>
    {
        this.killTweens();

        this.trophy.scale.set(0);
        this.trophy.y = 100;
        gsap.to(this.trophy.scale, { x: 1, y: 1, duration: 0.3, ease: 'back.out' });
        gsap.to(this.trophy, { y: 0, duration: 0.6, ease: 'back.out' });

        this.label.scale.set(0);
        this.label.y = 150;
        gsap.to(this.label.scale, { x: 1, y: 1, duration: 0.3, ease: 'back.out', delay: 0.1 });
        gsap.to(this.label, { y: 0, duration: 0.6, ease: 'back.out' });
    }

    protected async onClose(): Promise<void>
    {
        this.killTweens();

        gsap.to(this.trophy.scale, { x: 0.2, y: 0.2, duration: 0.25, ease: 'back.in' });
        await gsap.to(this.label.scale, { x: 0.2, y: 0.2, duration: 0.3, ease: 'back.in' });
    }

    private killTweens(): void
    {
        gsap.killTweensOf(this.trophy);
        gsap.killTweensOf(this.trophy.scale);
        gsap.killTweensOf(this.label);
        gsap.killTweensOf(this.label.scale);
    }
}
